import React from 'react';

import CaseStudyPage from 'containers/CaseStudyPage';
import { queryCMS } from 'utils/cms/api';
import { caseStudyPageQuery, getProjectBySlug } from 'utils/cms/gql';
import { ISR_TIMEOUT } from 'utils/config';

const Component = props => {
  return <CaseStudyPage {...props} />;
};

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}

export async function getStaticProps({ locale, query, params }) {
  const slug = query ? query.slug : params.slug;

  const projectsResults = await queryCMS({
    query: getProjectBySlug(slug),
  });
  const project = projectsResults.projects[0];

  const caseStudyResults = await queryCMS({
    query: caseStudyPageQuery(locale),
  });

  return {
    props: { ...caseStudyResults.caseStudyPage, project },
    revalidate: ISR_TIMEOUT,
  };
}

export default Component;
